import type { Seller } from 'types/seller'

import { useEffect, useState } from 'react'

import copy from 'copy.json'
import { useStore } from 'store'

import PageContainer from 'components/PageContainer'
import Badge from 'components/Badge'
import ContentHeader from 'components/ContentHeader'
import Spinner from 'components/Spinner'
import Button from 'components/Button'
import EditClientModal from 'modals/EditClientModal'

import UserDetails from '../UserDetails'
import { PencilIcon } from 'icons'

export default function DetailsScreen() {
  const [loading, setLoading] = useState(false)
  const [currentUserData, setCurrentUserData] = useState<Seller | null>(null)
  const [editClientModalOpen, setEditClientModalOpen] = useState(false)

  const { api } = useStore()

  const getSellerData = async () => {
    setCurrentUserData(await api.getClientDetails('seller'))
  }

  useEffect(() => {
    setLoading(true)

    getSellerData()
      .then(() => setLoading(false))
      .catch(console.error)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  if (!currentUserData) return null

  return (
    <>
      <PageContainer>
        <ContentHeader>
          <Badge user>{copy.seller.details.user}</Badge>

          <h1>{currentUserData.company_name}</h1>

          <Button secondary onClick={() => setEditClientModalOpen(true)}>
            <PencilIcon /> {copy.common.button.edit}
          </Button>
        </ContentHeader>

        <UserDetails currentUserData={currentUserData} />

        {loading && <Spinner />}
      </PageContainer>

      {/* Edit seller data */}
      <EditClientModal
        userType="seller"
        clientData={currentUserData}
        isModalOpen={editClientModalOpen}
        onModalClose={() => setEditClientModalOpen(false)}
        refreshData={getSellerData}
      />
    </>
  )
}
